// extracted by mini-css-extract-plugin
module.exports = {"delete":"FidAdminLevels_delete__30HGz","confirmLabel":"FidAdminLevels_confirmLabel__2mJ4R"};